import { shakeElement } from '~/shared/utils/animation';
import { AuthScreen } from './base-auth-screen';

export class TwoFactorAuthScreen extends AuthScreen {
  constructor(screen) {
    const formHandlerOptions = {
      defaultServerErrorMsg: 'Incorrect authentication code',
      onSubmitStart: () => { this.codeInput.disabled = true; },
      onError: () => {
        shakeElement(this.codeInput);
        this.codeInput.disabled = false;

        setTimeout(() => {
          this.codeInput.value = '';
        }, 0);
      },
    };

    super(screen, formHandlerOptions);
    this.codeInput = screen.querySelector('[data-2fa-input]');

    if (!this.codeInput) {
      throw new Error('Code input not found for 2fa auth screen');
    }

    this.bindListeners();
  }

  bindListeners() {
    this.screen.addEventListener('drb-code-input:complete', () => {
      this.form.requestSubmit();
    });
  }
}
